export class ComunicacaoModel {

  constructor(
    public id?: any,
    public anoSq?: number,
    public cdCentrusReg?: number,
    public dsLink?: string,
    public dsTitComunicados?: string,
    public dtIniVigencia?: Date,
    public dtRegistro?: Date,
    public dtTermVigencia?: Date,
    public histComunicados?: string,
    public sqComunicados?: number,
    public stComunicados?: number,
    public tpComunicados?: number,
  ) {
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/comunicado.model.ts